import { render, staticRenderFns } from "./FiveNav.vue?vue&type=template&id=60b9e8da&scoped=true"
import script from "./FiveNav.vue?vue&type=script&lang=js"
export * from "./FiveNav.vue?vue&type=script&lang=js"
import style0 from "./FiveNav.vue?vue&type=style&index=0&id=60b9e8da&prod&scoped=true&lang=css"
import style1 from "./FiveNav.vue?vue&type=style&index=1&id=60b9e8da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b9e8da",
  null
  
)

export default component.exports